// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 120 30%27%3E%3Ccircle cx=%2715%27 cy=%2715%27 r=%275%27 fill=%27white%27%3E%3Canimate attributeName=%27r%27 from=%273%27 to=%273%27 begin=%270s%27 dur=%270.8s%27 values=%273;5;3%27 calcMode=%27linear%27 repeatCount=%27indefinite%27 /%3E%3C/circle%3E%3Ccircle cx=%2760%27 cy=%2715%27 r=%275%27 fill=%27white%27%3E%3Canimate attributeName=%27r%27 from=%273%27 to=%273%27 begin=%270.3s%27 dur=%270.8s%27 values=%273;5;3%27 calcMode=%27linear%27 repeatCount=%27indefinite%27 /%3E%3Ccircle cx=%27105%27 cy=%2715%27 r=%275%27 fill=%27white%27%3E%3Canimate attributeName=%27r%27 from=%273%27 to=%273%27 begin=%270.6s%27 dur=%270.8s%27 values=%273;5;3%27 calcMode=%27linear%27 repeatCount=%27indefinite%27 /%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Chat.css */
.chat-container {
  width: 30vw;
  display: flex;
  flex-direction: column;
  height: 85vh;
  font-family: "Syne", sans-serif;
  border-left: 2px solid #ccc; /* Vertical border */
  overflow-x: hidden;
}

.chat-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
  border-radius: 8px 8px 0 0;
}

.chat-header-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 1.1rem;
  font-weight: 500;
  color: #2c3e50;
}

.remote-username {
  color: #6616cd;
  font-weight: 600;
  font-size: 0.95rem;
  opacity: 0.9;
}

.chat-language-select {
  padding: 8px 16px;
  border-radius: 20px;
  border: 2px solid #ccc;
  font-family: "Syne", sans-serif;
  cursor: pointer;
  background-color: transparent;
  outline: none;
}

.chat-messages {
  flex-grow: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  overflow-y: auto;
  padding: 15px;
  scrollbar-width: medium; /* For Firefox, adjusted to be slightly wider */
  scrollbar-color: #b2b2b2 #e0e0e0; /* For Firefox, thumb and track colors */
  padding-bottom: 40px; /* Add space for typing indicator */
}

/* Chrome, Edge, and Safari */
.chat-messages::-webkit-scrollbar {
  width: 12px; /* Adjusted width for a thicker scrollbar */
}

.chat-messages::-webkit-scrollbar-track {
  background: #e0e0e0; /* Light grey track */
  border-radius: 10px; /* Rounded corners for the track */
}

.chat-messages::-webkit-scrollbar-thumb {
  background-color: #b2b2b2; /* Grey color for the thumb */
  border-radius: 10px; /* Rounded corners for the thumb */
  border: 3px solid #e0e0e0; /* Slight border to create padding effect around the thumb */
}

.chat-messages::-webkit-scrollbar-thumb:hover {
  background: #9e9e9e; /* Slightly darker grey on hover */
}

.chat-input-container {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 15px;
  background-color: #fff;
  border-top: 1px solid #eee;
  border-bottom-left-radius: 30px;
  border-bottom-right-radius: 30px;
}

.chat-input {
  flex: 1 1;
  padding: 10px 15px;
  border: 1px solid #ddd;
  border-radius: 20px;
  font-size: 14px;
  outline: none;
  transition: border-color 0.3s;
}

.chat-input:focus {
  border-color: #6616cd;
}

.chat-input:disabled {
  background-color: #f5f5f5;
  cursor: not-allowed;
}

.chat-suggestions {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.suggestion-header {
  font-size: 20px;
  padding-bottom: 5px;
}

.suggestion-button {
  background: none;
  border: 1px solid #ccc;
  border-radius: 12px;
  padding: 5px;
  margin: 5px;
}

.rightAttached,
.leftAttached {
  padding: 8px 12px;
  margin: 5px;

  max-width: 70%;
  word-wrap: break-word;
}

.rightAttached {
  align-self: flex-end;
  background-color: #6200ea;
  border-radius: 20px 20px 0px 20px;
  color: white;
}

.leftAttached {
  align-self: flex-start;
  border-radius: 20px 20px 20px 0px;
  background-color: #e0e0e0;
  color: black;
}

.connectionStatusContainerLite {
  display: none;
}

/* Add these new styles */
.emoji-picker-container {
  position: relative;
  margin-right: 10px;
  z-index: 1000;
  flex-shrink: 0;
}

.emoji-button {
  background: none;
  border: none;
  font-size: 1.2rem;
  cursor: pointer;
  padding: 5px;
  border-radius: 5px;
  transition: background-color 0.3s;
}

.emoji-button:hover {
  background-color: #f0f0f0;
}

.emoji-picker-wrapper {
  position: absolute;
  bottom: 100%;
  left: 0rem;
  z-index: 1001;
  margin-bottom: 10px;
  transform-origin: bottom left;
  transform: scale(0.8); /* Make the picker slightly smaller */
  transition: transform 0.2s ease;
}

.send-button {
  background-color: #6616cd;
  color: white;
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.3s;
}

.send-button:hover:not(:disabled) {
  background-color: #5314a3;
}

.send-button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.send-button svg {
  width: 18px;
  height: 18px;
  fill: white;
  transition: all 0.3s;
}

.send-button .svg-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.2);
  transition: all 0.3s;
}

.send-button:hover .svg-wrapper {
  background-color: #6200ea;
  width: 30px;
  height: 35px;
}

.send-button:hover svg {
  width: 20px;
  height: 20px;
  transform: scale(1.1);
}

.typing-indicator {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background-color: rgba(102, 22, 205, 0.1);
  border-radius: 16px;
  margin-bottom: 8px;
  width: -moz-fit-content;
  width: fit-content;
  font-size: 0.9rem;
  color: #666;
  position: absolute;
  bottom: 100%;
  left: 20px;
  z-index: 10;
  animation: fadeIn 0.3s ease-in-out;
  -webkit-backdrop-filter: blur(4px);
          backdrop-filter: blur(4px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.typing-dots {
  display: flex;
  gap: 3px;
  margin-left: 4px;
}

.typing-dots span {
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background-color: #6616cd;
  animation: typingAnimation 1.4s infinite ease-in-out;
}

.typing-dots span:nth-child(1) { animation-delay: 0s; }
.typing-dots span:nth-child(2) { animation-delay: 0.2s; }
.typing-dots span:nth-child(3) { animation-delay: 0.4s; }

@keyframes typingAnimation {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-4px); }
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.typing-indicator::after {
  content: '';
  display: inline-block;
  width: 24px;
  height: 12px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}

.chat-input-wrapper {
  position: relative;
  width: 100%;
  background: white;
  padding: 15px;
  border-bottom-left-radius: 30px;
  border-bottom-right-radius: 30px;
  border-top: 1px solid #eee;
}

/* Make sure picker doesn't overflow on mobile */
@media (max-width: 500px) {
  .emoji-picker-wrapper {
    left: 0;
    transform: scale(0.6);
    height: 100%;
    top: -18rem;
    display: none;
  }
}

@media (max-width: 768px) {
  .chat-input-wrapper {
    padding: 10px;
    border-bottom-left-radius: 25px;
    border-bottom-right-radius: 25px;
  }

  .chat-input-container {
    padding: 6px;
    gap: 8px;
  }

  .chat-input {
    padding: 6px 12px;
    font-size: 0.9rem;
  }

  .emoji-button {
    font-size: 1.1rem;
    padding: 4px;
  }

  .send-button {
    width: 36px;
    height: 36px;
    padding: 6px;
  }

  .chat-container {
    width: 90vw;
    height: 36vh;
    margin-top: 4vh;
    border: 2px solid gainsboro;
    border-radius: 30px;
    margin-left: 5vw;
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.5);
    border-left: none; /* Remove the left border on mobile */
  }
  .chat-messages {
    border: 1px solid #9e9e9e;
    border-radius: 20px;
    width: 82vw;
    padding: 0;
    margin-left: 4vw;
    margin-right: 4vw;
  }
  .chat-suggestions {
    display: none;
  }
  .rightAttached {
    align-self: flex-start;
    background-color: white;
    max-width: 100%;
    color: black;
    padding: 1px 12px;
  }

  .leftAttached {
    align-self: flex-start;
    max-width: 100%;
    background-color: white;
    color: black;
    padding: 1px 12px;
  }
  .connectionStatusContainerLite {
    display: flex;
    width: 70%;
    justify-content: flex-end;
    align-items: center;
  }
  .connectionStatusTextLite {
    margin-left: 5%;
  }
  .emoji-picker-container,
   .emoji-picker-wrapper,
   .emoji-button {
     display: none;
   }
}

@media (max-width: 480px) {
  .chat-input-wrapper {
    padding: 8px;
  }

  .chat-input-container {
    padding: 4px;
    gap: 6px;
  }

  .emoji-picker-wrapper {
    left: 0;
    transform: scale(0.6);
    height: 100%;
    top: -18rem;
    display: none;
  }

  .typing-indicator {
    left: 10px;
    padding: 6px 10px;
    font-size: 0.85rem;
  }
}

.similarity-banner {
  background: linear-gradient(135deg, #6616cd, #7728d9);
  color: white;
  padding: 12px;
  text-align: center;
  font-size: 1rem;
  font-weight: 500;
  border-radius: 8px;
  margin-bottom: 16px;
  animation: fadeIn 0.5s ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 1024px) {
  .chat-container{
    width: 90vw;
    height: 50vh;
  }
   
}
@media screen and (min-width: 500px) and (max-width: 1024px){
  .emoji-picker-wrapper{
    transform: scale(0.6);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/testChat/testChat.css"],"names":[],"mappings":"AAAA,aAAa;AACb;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,+BAA+B;EAC/B,2BAA2B,EAAE,oBAAoB;EACjD,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,+BAA+B;EAC/B,eAAe;EACf,6BAA6B;EAC7B,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;EACb,uBAAuB,EAAE,+CAA+C;EACxE,gCAAgC,EAAE,wCAAwC;EAC1E,oBAAoB,EAAE,mCAAmC;AAC3D;;AAEA,6BAA6B;AAC7B;EACE,WAAW,EAAE,2CAA2C;AAC1D;;AAEA;EACE,mBAAmB,EAAE,qBAAqB;EAC1C,mBAAmB,EAAE,kCAAkC;AACzD;;AAEA;EACE,yBAAyB,EAAE,6BAA6B;EACxD,mBAAmB,EAAE,kCAAkC;EACvD,yBAAyB,EAAE,4DAA4D;AACzF;;AAEA;EACE,mBAAmB,EAAE,kCAAkC;AACzD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,0BAA0B;EAC1B,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,WAAW;AACb;;AAEA;;EAEE,iBAAiB;EACjB,WAAW;;EAEX,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,iCAAiC;EACjC,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,iCAAiC;EACjC,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,qBAAqB,EAAE,qCAAqC;EAC5D,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;EAC1C,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yCAAyC;EACzC,mBAAmB;EACnB,kBAAkB;EAClB,uBAAkB;EAAlB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,WAAW;EACX,kCAAkC;EAClC,kCAA0B;UAA1B,0BAA0B;EAC1B,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,oDAAoD;AACtD;;AAEA,iCAAiC,mBAAmB,EAAE;AACtD,iCAAiC,qBAAqB,EAAE;AACxD,iCAAiC,qBAAqB,EAAE;;AAExD;EACE,WAAW,wBAAwB,EAAE;EACrC,MAAM,2BAA2B,EAAE;AACrC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,yDAAypB;EACzpB,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,+BAA+B;EAC/B,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA,gDAAgD;AAChD;EACE;IACE,OAAO;IACP,qBAAqB;IACrB,YAAY;IACZ,WAAW;IACX,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;IACb,+BAA+B;IAC/B,gCAAgC;EAClC;;EAEA;IACE,YAAY;IACZ,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,2BAA2B;IAC3B,mBAAmB;IACnB,gBAAgB;IAChB,sCAAsC;IACtC,iBAAiB,EAAE,qCAAqC;EAC1D;EACA;IACE,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;IACX,UAAU;IACV,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,aAAa;EACf;EACA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,eAAe;IACf,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,eAAe;IACf,uBAAuB;IACvB,YAAY;IACZ,iBAAiB;EACnB;EACA;IACE,aAAa;IACb,UAAU;IACV,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;EACA;;;KAGG,aAAa;GACf;AACH;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,QAAQ;EACV;;EAEA;IACE,OAAO;IACP,qBAAqB;IACrB,YAAY;IACZ,WAAW;IACX,aAAa;EACf;;EAEA;IACE,UAAU;IACV,iBAAiB;IACjB,kBAAkB;EACpB;AACF;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,WAAW;IACX,YAAY;EACd;;AAEF;AACA;EACE;IACE,qBAAqB;EACvB;AACF","sourcesContent":["/* Chat.css */\n.chat-container {\n  width: 30vw;\n  display: flex;\n  flex-direction: column;\n  height: 85vh;\n  font-family: \"Syne\", sans-serif;\n  border-left: 2px solid #ccc; /* Vertical border */\n  overflow-x: hidden;\n}\n\n.chat-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 16px;\n  background: #f8f9fa;\n  border-bottom: 1px solid #e9ecef;\n  border-radius: 8px 8px 0 0;\n}\n\n.chat-header-title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 1.1rem;\n  font-weight: 500;\n  color: #2c3e50;\n}\n\n.remote-username {\n  color: #6616cd;\n  font-weight: 600;\n  font-size: 0.95rem;\n  opacity: 0.9;\n}\n\n.chat-language-select {\n  padding: 8px 16px;\n  border-radius: 20px;\n  border: 2px solid #ccc;\n  font-family: \"Syne\", sans-serif;\n  cursor: pointer;\n  background-color: transparent;\n  outline: none;\n}\n\n.chat-messages {\n  flex-grow: 1;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  background-color: #fff;\n  overflow-y: auto;\n  padding: 15px;\n  scrollbar-width: medium; /* For Firefox, adjusted to be slightly wider */\n  scrollbar-color: #b2b2b2 #e0e0e0; /* For Firefox, thumb and track colors */\n  padding-bottom: 40px; /* Add space for typing indicator */\n}\n\n/* Chrome, Edge, and Safari */\n.chat-messages::-webkit-scrollbar {\n  width: 12px; /* Adjusted width for a thicker scrollbar */\n}\n\n.chat-messages::-webkit-scrollbar-track {\n  background: #e0e0e0; /* Light grey track */\n  border-radius: 10px; /* Rounded corners for the track */\n}\n\n.chat-messages::-webkit-scrollbar-thumb {\n  background-color: #b2b2b2; /* Grey color for the thumb */\n  border-radius: 10px; /* Rounded corners for the thumb */\n  border: 3px solid #e0e0e0; /* Slight border to create padding effect around the thumb */\n}\n\n.chat-messages::-webkit-scrollbar-thumb:hover {\n  background: #9e9e9e; /* Slightly darker grey on hover */\n}\n\n.chat-input-container {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 15px;\n  background-color: #fff;\n  border-top: 1px solid #eee;\n  border-bottom-left-radius: 30px;\n  border-bottom-right-radius: 30px;\n}\n\n.chat-input {\n  flex: 1;\n  padding: 10px 15px;\n  border: 1px solid #ddd;\n  border-radius: 20px;\n  font-size: 14px;\n  outline: none;\n  transition: border-color 0.3s;\n}\n\n.chat-input:focus {\n  border-color: #6616cd;\n}\n\n.chat-input:disabled {\n  background-color: #f5f5f5;\n  cursor: not-allowed;\n}\n\n.chat-suggestions {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.suggestion-header {\n  font-size: 20px;\n  padding-bottom: 5px;\n}\n\n.suggestion-button {\n  background: none;\n  border: 1px solid #ccc;\n  border-radius: 12px;\n  padding: 5px;\n  margin: 5px;\n}\n\n.rightAttached,\n.leftAttached {\n  padding: 8px 12px;\n  margin: 5px;\n\n  max-width: 70%;\n  word-wrap: break-word;\n}\n\n.rightAttached {\n  align-self: flex-end;\n  background-color: #6200ea;\n  border-radius: 20px 20px 0px 20px;\n  color: white;\n}\n\n.leftAttached {\n  align-self: flex-start;\n  border-radius: 20px 20px 20px 0px;\n  background-color: #e0e0e0;\n  color: black;\n}\n\n.connectionStatusContainerLite {\n  display: none;\n}\n\n/* Add these new styles */\n.emoji-picker-container {\n  position: relative;\n  margin-right: 10px;\n  z-index: 1000;\n  flex-shrink: 0;\n}\n\n.emoji-button {\n  background: none;\n  border: none;\n  font-size: 1.2rem;\n  cursor: pointer;\n  padding: 5px;\n  border-radius: 5px;\n  transition: background-color 0.3s;\n}\n\n.emoji-button:hover {\n  background-color: #f0f0f0;\n}\n\n.emoji-picker-wrapper {\n  position: absolute;\n  bottom: 100%;\n  left: 0rem;\n  z-index: 1001;\n  margin-bottom: 10px;\n  transform-origin: bottom left;\n  transform: scale(0.8); /* Make the picker slightly smaller */\n  transition: transform 0.2s ease;\n}\n\n.send-button {\n  background-color: #6616cd;\n  color: white;\n  border: none;\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: background-color 0.3s;\n}\n\n.send-button:hover:not(:disabled) {\n  background-color: #5314a3;\n}\n\n.send-button:disabled {\n  background-color: #ccc;\n  cursor: not-allowed;\n}\n\n.send-button svg {\n  width: 18px;\n  height: 18px;\n  fill: white;\n  transition: all 0.3s;\n}\n\n.send-button .svg-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  background-color: rgba(255, 255, 255, 0.2);\n  transition: all 0.3s;\n}\n\n.send-button:hover .svg-wrapper {\n  background-color: #6200ea;\n  width: 30px;\n  height: 35px;\n}\n\n.send-button:hover svg {\n  width: 20px;\n  height: 20px;\n  transform: scale(1.1);\n}\n\n.typing-indicator {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 12px;\n  background-color: rgba(102, 22, 205, 0.1);\n  border-radius: 16px;\n  margin-bottom: 8px;\n  width: fit-content;\n  font-size: 0.9rem;\n  color: #666;\n  position: absolute;\n  bottom: 100%;\n  left: 20px;\n  z-index: 10;\n  animation: fadeIn 0.3s ease-in-out;\n  backdrop-filter: blur(4px);\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.typing-dots {\n  display: flex;\n  gap: 3px;\n  margin-left: 4px;\n}\n\n.typing-dots span {\n  width: 4px;\n  height: 4px;\n  border-radius: 50%;\n  background-color: #6616cd;\n  animation: typingAnimation 1.4s infinite ease-in-out;\n}\n\n.typing-dots span:nth-child(1) { animation-delay: 0s; }\n.typing-dots span:nth-child(2) { animation-delay: 0.2s; }\n.typing-dots span:nth-child(3) { animation-delay: 0.4s; }\n\n@keyframes typingAnimation {\n  0%, 100% { transform: translateY(0); }\n  50% { transform: translateY(-4px); }\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.typing-indicator::after {\n  content: '';\n  display: inline-block;\n  width: 24px;\n  height: 12px;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 120 30'%3E%3Ccircle cx='15' cy='15' r='5' fill='white'%3E%3Canimate attributeName='r' from='3' to='3' begin='0s' dur='0.8s' values='3;5;3' calcMode='linear' repeatCount='indefinite' /%3E%3C/circle%3E%3Ccircle cx='60' cy='15' r='5' fill='white'%3E%3Canimate attributeName='r' from='3' to='3' begin='0.3s' dur='0.8s' values='3;5;3' calcMode='linear' repeatCount='indefinite' /%3E%3Ccircle cx='105' cy='15' r='5' fill='white'%3E%3Canimate attributeName='r' from='3' to='3' begin='0.6s' dur='0.8s' values='3;5;3' calcMode='linear' repeatCount='indefinite' /%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n}\n\n.chat-input-wrapper {\n  position: relative;\n  width: 100%;\n  background: white;\n  padding: 15px;\n  border-bottom-left-radius: 30px;\n  border-bottom-right-radius: 30px;\n  border-top: 1px solid #eee;\n}\n\n/* Make sure picker doesn't overflow on mobile */\n@media (max-width: 500px) {\n  .emoji-picker-wrapper {\n    left: 0;\n    transform: scale(0.6);\n    height: 100%;\n    top: -18rem;\n    display: none;\n  }\n}\n\n@media (max-width: 768px) {\n  .chat-input-wrapper {\n    padding: 10px;\n    border-bottom-left-radius: 25px;\n    border-bottom-right-radius: 25px;\n  }\n\n  .chat-input-container {\n    padding: 6px;\n    gap: 8px;\n  }\n\n  .chat-input {\n    padding: 6px 12px;\n    font-size: 0.9rem;\n  }\n\n  .emoji-button {\n    font-size: 1.1rem;\n    padding: 4px;\n  }\n\n  .send-button {\n    width: 36px;\n    height: 36px;\n    padding: 6px;\n  }\n\n  .chat-container {\n    width: 90vw;\n    height: 36vh;\n    margin-top: 4vh;\n    border: 2px solid gainsboro;\n    border-radius: 30px;\n    margin-left: 5vw;\n    box-shadow: 0 0 8px rgba(0, 0, 0, 0.5);\n    border-left: none; /* Remove the left border on mobile */\n  }\n  .chat-messages {\n    border: 1px solid #9e9e9e;\n    border-radius: 20px;\n    width: 82vw;\n    padding: 0;\n    margin-left: 4vw;\n    margin-right: 4vw;\n  }\n  .chat-suggestions {\n    display: none;\n  }\n  .rightAttached {\n    align-self: flex-start;\n    background-color: white;\n    max-width: 100%;\n    color: black;\n    padding: 1px 12px;\n  }\n\n  .leftAttached {\n    align-self: flex-start;\n    max-width: 100%;\n    background-color: white;\n    color: black;\n    padding: 1px 12px;\n  }\n  .connectionStatusContainerLite {\n    display: flex;\n    width: 70%;\n    justify-content: flex-end;\n    align-items: center;\n  }\n  .connectionStatusTextLite {\n    margin-left: 5%;\n  }\n  .emoji-picker-container,\n   .emoji-picker-wrapper,\n   .emoji-button {\n     display: none;\n   }\n}\n\n@media (max-width: 480px) {\n  .chat-input-wrapper {\n    padding: 8px;\n  }\n\n  .chat-input-container {\n    padding: 4px;\n    gap: 6px;\n  }\n\n  .emoji-picker-wrapper {\n    left: 0;\n    transform: scale(0.6);\n    height: 100%;\n    top: -18rem;\n    display: none;\n  }\n\n  .typing-indicator {\n    left: 10px;\n    padding: 6px 10px;\n    font-size: 0.85rem;\n  }\n}\n\n.similarity-banner {\n  background: linear-gradient(135deg, #6616cd, #7728d9);\n  color: white;\n  padding: 12px;\n  text-align: center;\n  font-size: 1rem;\n  font-weight: 500;\n  border-radius: 8px;\n  margin-bottom: 16px;\n  animation: fadeIn 0.5s ease-in-out;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@media (max-width: 1024px) {\n  .chat-container{\n    width: 90vw;\n    height: 50vh;\n  }\n   \n}\n@media screen and (min-width: 500px) and (max-width: 1024px){\n  .emoji-picker-wrapper{\n    transform: scale(0.6);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
